import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const protocolRouter: RouteConfig = {
  path: '/protocol',
  component: Layout,
  redirect: '/protocols/protocol_list',
  name: '协议管理',
  meta: {
    title: '协议管理'
  },

  children: [
    {
      path: 'protocolList/type/1',
      name: 'protocolList1',
      component: () => import(/* webpackChunkName: "protocols" */'@/views/protocols/protocolList.vue'),
      meta: {
        title: '合伙人协议管理'
      }
    },
    {

      path: 'protocolList/type/2',
      name: 'protocolList2',
      component: () => import(/* webpackChunkName: "protocols" */'@/views/protocols/protocolList.vue'),
      meta: {
        title: '社区委托运营协议管理'
      }
    },
    {
      path: 'protocolList/type/3',
      name: 'protocolList3',
      component: () => import(/* webpackChunkName: "protocols" */'@/views/protocols/protocolList.vue'),
      meta: {
        title: '其他合同列表'
      }
    }
  ]
}

export default protocolRouter
